export default "__VITE_ASSET__BBEEmU9H__"